import { type FC, useState } from "react";

interface StatusToggleProps {
	objectId: string;
	currentStatus: string;
	onToggle: (objectId: string, newStatus: "ACTIVE" | "PAUSED") => void;
	isPending: boolean;
}

export const StatusToggle: FC<StatusToggleProps> = ({
	objectId,
	currentStatus,
	onToggle,
	isPending,
}) => {
	const [showConfirm, setShowConfirm] = useState(false);
	const isActive = currentStatus === "ACTIVE";
	const newStatus = isActive ? "PAUSED" : "ACTIVE";

	if (showConfirm) {
		return (
			<div style={{ display: "flex", gap: 4, alignItems: "center" }}>
				<span style={{ fontSize: "0.8rem" }}>
					{isActive ? "Pause?" : "Activate?"}
				</span>
				<button
					type="button"
					className="btn btn-sm btn-outline-success"
					disabled={isPending}
					onClick={() => {
						onToggle(objectId, newStatus);
						setShowConfirm(false);
					}}
				>
					Yes
				</button>
				<button
					type="button"
					className="btn btn-sm btn-outline-secondary"
					onClick={() => setShowConfirm(false)}
				>
					No
				</button>
			</div>
		);
	}

	return (
		<button
			type="button"
			className={`btn btn-sm ${isActive ? "btn-outline-warning" : "btn-outline-success"}`}
			disabled={
				isPending || (currentStatus !== "ACTIVE" && currentStatus !== "PAUSED")
			}
			onClick={() => setShowConfirm(true)}
		>
			{isActive ? "Pause" : "Activate"}
		</button>
	);
};
